var _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    transform: "rotate(90 26 26)",
    fill: "#FAEDCD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3625,
    cy: 35.2019,
    r: 2.06254,
    transform: "rotate(21.6755 38.3625 35.2019)",
    fill: "#FAC746"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.1339,
    cy: 37.7278,
    r: 1.65003,
    transform: "rotate(21.6755 39.1339 37.7278)",
    fill: "#FAC746"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0579,
    cy: 39.8708,
    r: 1.23752,
    transform: "rotate(21.6755 40.0579 39.8708)",
    fill: "#FAC746"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6757,
    cy: 25.6805,
    r: 15.2757,
    fill: "#FFF3F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0311 32.0292L23.6785 33.0786C23.9254 34.1028 24.8787 34.6857 26.4149 34.3153C27.8633 33.9661 28.1104 32.7326 28.0311 32.0292Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8718 10.4054C14.2617 10.6358 10.802 19.8869 10.4 24.6276L19.8815 23.0419L25.4124 21.725L31.9967 23.3052L40.9515 24.6223C40.6881 19.3546 37.0008 10.1421 24.8718 10.4054Z",
    fill: "#FAC746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2717 30.9867C24.5622 30.9867 25.6083 29.9156 25.6083 28.5944C25.6083 27.2732 24.5622 26.2021 23.2717 26.2021C21.9812 26.2021 20.935 27.2732 20.935 28.5944C20.935 29.9156 21.9812 30.9867 23.2717 30.9867Z",
    fill: "#202123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5087 30.9867C29.7992 30.9867 30.8453 29.9156 30.8453 28.5944C30.8453 27.2732 29.7992 26.2021 28.5087 26.2021C27.2182 26.2021 26.172 27.2732 26.172 28.5944C26.172 29.9156 27.2182 30.9867 28.5087 30.9867Z",
    fill: "#202123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4216 28.5942H29.8089",
    stroke: "#202123",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4215 26.6694C23.4215 26.6694 21.1009 26.8434 21.5076 29.2039L23.4215 26.6694Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7785 26.6694C28.7785 26.6694 26.4578 26.8434 26.8646 29.2039L28.7785 26.6694Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile5);
export default __webpack_public_path__ + "static/media/img_profile_5.979e266d11bbaa7ad4d5ae932ed39f9a.svg";
export { ForwardRef as ReactComponent };